import administracao from './administracao'
import autenticacao from './autenticacao'
import cadastro from './cadastro'
import comum from './comum'
import perfil from './perfil'

const baseApiUrl = `/api`

export default {
    administracao: administracao(baseApiUrl),
    autenticacao: autenticacao(baseApiUrl),
    cadastro: cadastro(baseApiUrl),
    comum: comum(baseApiUrl),
    perfil: perfil(baseApiUrl),
}